import { defineMessages } from 'react-intl';

/** The copy of the mailbox warm-up (design t2, t3; fym-shared `mailboxRamp.ts`). */
export const warmupMessages = defineMessages({
  title: { id: 'app.outreach.live.warmup.title', defaultMessage: 'Your mailbox warms up' },
  dayOf: { id: 'app.outreach.live.warmup.dayOf', defaultMessage: 'Day {day} of {total}' },
  now: {
    id: 'app.outreach.live.warmup.now',
    defaultMessage: '{cap, plural, one {# pitch} other {# pitches}} a day now.',
  },
  next: { id: 'app.outreach.live.warmup.next', defaultMessage: '{cap} a day from {date}.' },
  why: { id: 'app.outreach.live.warmup.why', defaultMessage: 'A slow start keeps your pitches out of spam.' },
  today: {
    id: 'app.outreach.live.warmup.today',
    defaultMessage: 'Today: {cap, plural, one {# pitch} other {# pitches}}.',
  },
  fromDate: { id: 'app.outreach.live.warmup.fromDate', defaultMessage: 'From {date}: {cap} a day.' },
  whyLong: {
    id: 'app.outreach.live.warmup.whyLong',
    defaultMessage:
      'Mail providers trust a mailbox that starts slowly, so your pitches land in the inbox, not in spam.',
  },
  howItWorks: { id: 'app.outreach.live.warmup.howItWorks', defaultMessage: 'How the warm-up works' },
  rampStep: { id: 'app.outreach.live.warmup.rampStep', defaultMessage: '{perDay} from day {fromDay}' },
  rampAria: { id: 'app.outreach.live.warmup.rampAria', defaultMessage: 'Pitches a day: {steps}. Today is day {day}.' },
  rampDay0: { id: 'app.outreach.live.warmup.rampDay0', defaultMessage: 'day {day}' },
});
